import React, { FC, useEffect, useState } from 'react';
import {
    Item, ActionGroup, Flex, View
} from '@adobe/react-spectrum';
import Move from '@spectrum-icons/workflow/Move';
import RotateCWBold from '@spectrum-icons/workflow/RotateCWBold';
import Maximize from '@spectrum-icons/workflow/Maximize';
import ZoomIn from '@spectrum-icons/workflow/ZoomIn';
import ZoomOut from '@spectrum-icons/workflow/ZoomOut';

import { ContentAnimation } from '~/Scene/Content/contentAnimation';
import { _system } from '~/Services/Studio/studioScene';

import { CanvasGizmoGeometry, GizmoMode } from './canvasGizmoGeometry';
import { ModelSelectEvent, modelSelectObservable } from '~/Components/Model/modelList';

export const CanvasGizmoIcon: FC = () => {
    const [mode, setMode] = useState<GizmoMode>(null);
    const [content, setContent] = useState<ContentAnimation>(null);

    const setZoom = (action: React.Key) => {
        if (action === 'in') _system.arcCamera.radius -= 0.2;
        else if (action === 'out') _system.arcCamera.radius += 0.2;
    };

    useEffect(() => {
        modelSelectObservable.on(ModelSelectEvent.Select, setContent);
        return () => { modelSelectObservable.off(ModelSelectEvent.Select, setContent); };
    }, []);

    return (
        <Flex
            flex
            alignItems="center"
            direction="column"
            gap="size-100"
            position="absolute"
            zIndex={2}
            bottom="20px"
            right="20px"
        >
            {mode
                && (
                    <CanvasGizmoGeometry
                        mode={mode}
                        content={content}
                    />
                )}
            <View backgroundColor="gray-100" borderRadius="medium">
                <Flex flex alignItems="center" direction="row">
                    {content
                        && (
                            <ActionGroup
                                margin="size-150"
                                onAction={(mode: GizmoMode) => { setMode(null); setMode(mode); }}
                            >
                                {/* <Item key="">
                                    <DevicePhone size="M" aria-label="Device Mobile" />
                                </Item> */}
                                <Item key="position"><Move size="M" aria-label="Move" /></Item>
                                <Item key="rotation"><RotateCWBold size="M" aria-label="Rotate" /></Item>
                                <Item key="scale"><Maximize size="M" aria-label="Scale" /></Item>
                            </ActionGroup>
                        )}
                    <ActionGroup margin="size-150" onAction={(zoom: GizmoMode) => { setZoom(zoom); }}>
                        <Item key="in"><ZoomIn size="M" aria-label="Zoom In" /></Item>
                        <Item key="out"><ZoomOut size="M" aria-label="Zoom Out" /></Item>
                    </ActionGroup>
                </Flex>
            </View>
        </Flex>
    );
};
